module.exports = __webpack_public_path__ + "static/media/icn-arrow-down.ff1234b2.svg";